module.exports = __webpack_public_path__ + "media/Video (9).397a0409.mp4";